import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RootState } from '../../store/store.state';
import { select, Store } from '@ngrx/store';
import { Alert } from 'quotient-ng-core';
import { fadeOut, flipInX } from 'ng-animate';
import { transition, trigger, useAnimation } from '@angular/animations';
import { selectAlerts } from '../store/alerts.selectors';
import { RemoveAlert } from '../store/alerts.action';

@Component({
    selector: 'q-alert-detail',
    templateUrl: './alert-detail.component.html',
    styleUrls: ['./alert-detail.component.scss'],
    animations: [
        trigger('flyInOut', [
            transition(':enter', useAnimation(flipInX), {
                params: { timing: 0.2, delay: 0 }
            }),
            transition(':leave', useAnimation(fadeOut), {
                params: { timing: 0.2, delay: 0 }
            })
        ])
    ]
})
export class AlertDetailComponent implements OnInit {
    alerts: Alert[];
    MAX_VISIBLE = 2;

    constructor(private router: Router, private store: Store<RootState>) {
        store
            .pipe(select(selectAlerts))
            .subscribe(alerts => (this.alerts = alerts));
    }

    ngOnInit() {}

    handleAlertClosed(alert: Alert) {
        this.store.dispatch(new RemoveAlert(alert.id));
    }
}
